import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Menu`

export function buscarTodos(buscar, idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarTodos`, {
    params: { buscar, idUsuario },
    meta: {
      toastMessage: 'Ocurrió un error al obtener los menús.',
      tipoError: 'menu'
    }
  })
}
